import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  addToSaved,
  addToSavedFailure,
  addToSavedSuccess,
  removeFromSaved,
  removeFromSavedFailure,
  removeFromSavedSuccess,
} from './saved.actions';
import { SavedFacadeService } from './saved.facade';
import { map, switchMap, take } from 'rxjs';
import { SnackbarService } from '../../services/snackbar.service';

@Injectable()
export class SavedEffects {
  constructor(
    private actions$: Actions,
    private savedFacadeService: SavedFacadeService,
    private snackbarService: SnackbarService
  ) {}

  public addToSaved$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addToSaved),
      switchMap(({ institution }) => {
        return this.savedFacadeService.institutions$.pipe(
          take(1),
          map((institutions) => {
            if (
              institutions.some((item) => item?.id === institution.id) // exist
            ) {
              return addToSavedFailure({
                message: 'The Institution already exists',
              });
            }
            this.snackbarService.success('Institution was saved');
            return addToSavedSuccess({ institution });
          })
        );
      })
    )
  );

  public removeFromSaved$ = createEffect(() =>
    this.actions$.pipe(
      ofType(removeFromSaved),
      switchMap(({ institution }) => {
        return this.savedFacadeService.institutions$.pipe(
          take(1),
          map((institutions) => {
            if (
              !institutions.some((item) => item?.id === institution.id) // not exist
            ) {
              return removeFromSavedFailure({
                message: 'The institution is not exists',
              });
            }
            return removeFromSavedSuccess({ institution });
          })
        );
      })
    )
  );
}
